import * as React from 'react';
import classnames from 'classnames';
import { useFeatureToggles } from '@grandvisionhq/state';

const ProductDetailStack = ({ children , className , spacing ='full' ,  })=>{
    const { isPdpDrawerLayoutEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail-stack', {
            'product-detail-stack--full-spacing': spacing === 'full',
            'product-detail-stack--half-spacing': spacing === 'half',
            'product-detail-stack--no-drawer': !isPdpDrawerLayoutEnabled
        }, className)
    }, children);
};

export { ProductDetailStack };
//# sourceMappingURL=ProductDetailStack.js.map
